class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('[data-facets-wrapper]');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('[data-facets-remove]').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.querySelector('[data-facets-products-grid-container]').querySelector('[data-facets-product-grid]').classList.add('loading');
    document.querySelectorAll('[data-facets-count]').forEach((el) => el.classList.add('loading'));
    document.querySelectorAll('[data-facets-count-desktop]').forEach((el) => el.classList.add('loading'));

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.querySelector('[data-facets-products-grid-container]').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-facets-products-grid-container]').innerHTML;
    
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const sourceEl =
      parsed.querySelector('[data-facets-count]') || parsed.querySelector('[data-facets-count-desktop]');
    if (!sourceEl) return;

    const countText = sourceEl.textContent.trim();

    document.querySelectorAll('[data-facets-count]').forEach((el) => {
      el.textContent = countText;
      el.classList.remove('loading');
    });
    document.querySelectorAll('[data-facets-count-desktop]').forEach((el) => {
      el.textContent = countText;
      el.classList.remove('loading');
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '[data-facets-form] [data-facets-filter], [data-facets-form-mobile] [data-facets-filter]'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('[data-facets-filter]') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`[data-facets-filter][data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('[data-facets-filter]'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['[data-facets-actives-mobile]', '[data-facets-actives]'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('[data-facets-selected]');
    const sourceElement = source.querySelector('[data-facets-selected]');

    const targetElementAccessibility = target.querySelector('[data-facets-summary]');
    const sourceElementAccessibility = source.querySelector('[data-facets-summary]');

    if (sourceElement && targetElement) {
      target.querySelector('[data-facets-selected]').outerHTML = source.querySelector('[data-facets-selected]').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('[data-facets-summary]').outerHTML = source.querySelector('[data-facets-summary]').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-facets-product-grid]').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class DynamicTitleUpdater {
  constructor() {
    this.baseTitle = document.querySelector('meta[property="og:title"]')?.getAttribute('content') || document.title.split(' | ')[0];
    this.shopDomain = window.shopDomain;
    this.init();
  }

  init() {
    // Hook into the existing renderPage method
    const originalRenderPage = FacetFiltersForm.renderPage;
    FacetFiltersForm.renderPage = (searchParams, event, updateURLHash = true) => {
      originalRenderPage.call(FacetFiltersForm, searchParams, event, updateURLHash);
      this.updateTitle(searchParams);
    };

    // Update title on page load if filters are active
    if (window.location.search) {
      this.updateTitle(window.location.search.slice(1));
    }
  }

  updateTitle(searchParams) {
    const params = new URLSearchParams(searchParams);
    const activeFilters = [];
    let pageNumber = null;

    // Extract filter values
    for (const [key, value] of params) {
      if (key.startsWith('filter.')) {
        // Clean up the filter value
        const filterValue = decodeURIComponent(value).replace(/\+/g, ' ');
        activeFilters.push(filterValue);
      } else if (key === 'page') {
        pageNumber = value;
      }
    }

    // Build the new title
    let newTitle = this.baseTitle;

    // Add filters
    if (activeFilters.length > 0) {
      newTitle += ' - ' + activeFilters.join(', ');
    }

    // Add page number
    if (pageNumber && pageNumber !== '1') {
      newTitle += ' - Page ' + pageNumber;
    }

    // Add shop domain
    newTitle += ' | ' + this.shopDomain;

    // Update the title
    document.title = newTitle;
  }
}

// Initialize the title updater
if (customElements.get('facet-filters-form')) {
  new DynamicTitleUpdater();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    // State pour savoir si le dernier input venait du clavier
    this.lastInteractionWasKeyboard = false;

    // Listeners globaux encapsulés dans la classe
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);

    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('mousedown', this.handleMouseDown);
    window.addEventListener('touchstart', this.handleTouchStart);

    // Setup du lien facet
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  // Détecte si on se déplace au clavier
  handleKeyDown(e) {
    if (e.key === 'Tab' || e.key === 'Shift') {
      this.lastInteractionWasKeyboard = true;
    }
  }

  handleMouseDown() {
    this.lastInteractionWasKeyboard = false;
  }

  handleTouchStart() {
    this.lastInteractionWasKeyboard = false;
  }

  closeFilter(event) {
    event.preventDefault();

    // Trigger the original filter close logic
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') {
      form.onActiveFilterClick(event);
    }

    // Focus uniquement si déplacement clavier
    if (!this.lastInteractionWasKeyboard) return;

    setTimeout(() => {
      let sortBy;
      if (window.matchMedia('(max-width: 1080px)').matches) {
        // Mobile
        sortBy = document.querySelector('ul#SortBy');
      } else {
        // Desktop
        sortBy = document.querySelector('select#SortBy');
      }

      if (sortBy) {
        sortBy.focus();
      } 
    }, 10); // délai pour que le DOM se mette à jour
  }

  disconnectedCallback() {
    // Nettoyage des listeners quand l'élément est supprimé
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('mousedown', this.handleMouseDown);
    window.removeEventListener('touchstart', this.handleTouchStart);
  }
}

customElements.define('facet-remove', FacetRemove);